import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { AgencyContext } from 'Context/Agency';
import ReportPendingApproval from './ReportPendingApproval';
import ReportPendingApprovalOld from './ReportPendingApprovalOld';

const MainReportPendingApproval = () => {
    const { agencySingleData, GetAgencySingleData } = useContext(AgencyContext);

    const localStoreData = useSelector((state) => state.Agency.localStoreData);

    const [isNewFRW, setIsNewFRW] = useState(false);

    useEffect(() => {
        const agencyId = localStoreData?.AgencyID;
        if (agencyId) {
            GetAgencySingleData(agencyId);
        }
    }, [localStoreData?.AgencyID, GetAgencySingleData]);

    useEffect(() => {

        setIsNewFRW(agencySingleData[0]?.isNewFRW);
        
    }, [agencySingleData[0]?.isNewFRW])



    return (
        <>
            {isNewFRW ? <ReportPendingApproval /> : <ReportPendingApprovalOld />}
        </>
    )
}
export default MainReportPendingApproval;
